import { WORKFLOWS } from '../../../constants/space-wizard.constants';

interface WorkflowSelectorProps {
  currentWorkflow: string;
  onSelect: (value: string) => void;
}

export function WorkflowSelector({ currentWorkflow, onSelect }: WorkflowSelectorProps) {
  return (
    <div>
      <label style={{ display: 'block', marginBottom: '0.75rem', fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>Type de réservation <span style={{ color: '#8E0B56' }}>*</span></label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {WORKFLOWS.map((wf) => {
          const isSelected = currentWorkflow === wf.value;
          return (
            <button
              key={wf.value}
              onClick={() => onSelect(wf.value)}
              type="button"
              style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem', background: isSelected ? `${wf.color}10` : 'white', border: `2px solid ${isSelected ? wf.color : '#e5e7eb'}`, borderRadius: '12px', cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s ease' }}
            >
              <div style={{ width: '20px', height: '20px', borderRadius: '50%', border: `2px solid ${isSelected ? wf.color : '#e5e7eb'}`, background: isSelected ? wf.color : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                {isSelected && <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'white' }} />}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '0.95rem', fontWeight: 600, color: '#00303c', marginBottom: '0.25rem' }}>{wf.label}</div>
                <div style={{ fontSize: '0.85rem', color: '#666' }}>{wf.description}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
